module.exports = __webpack_public_path__ + "static/media/EmployeeManage.2da8182d.svg";